import { db } from "@db";
import { updateSettings } from "@db/settings";
import { createFileRoute } from "@tanstack/react-router";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSet,
} from "@ui/field";
import { Switch } from "@ui/switch";
import { useLiveQuery } from "dexie-react-hooks";

export const Route = createFileRoute("/settings/help")({
  component: HelpSettingsComponent,
});

function HelpSettingsComponent() {
  const settings = useLiveQuery(() => db.settings.get("settings"));

  if (!settings) {
    return null;
  }

  const completionTracking = settings.completionTracking ?? true;

  return (
    <div className="max-w-xl p-6">
      <FieldSet>
        <FieldLegend>Completion</FieldLegend>
        <FieldGroup>
          <Field orientation="horizontal">
            <Switch
              id="completionTracking"
              checked={completionTracking}
              onCheckedChange={(checked) =>
                updateSettings({ completionTracking: checked })
              }
            />
            <FieldLabel htmlFor="completionTracking">
              <FieldContent>
                Track feature completion
                <FieldDescription>
                  Show progress indicators and completion status as you explore
                  features.
                </FieldDescription>
              </FieldContent>
            </FieldLabel>
          </Field>
        </FieldGroup>
      </FieldSet>
    </div>
  );
}
